import { otto } from '@otto-ec/global-resources/nexus';
import type { SdaRenderedEventData } from '@shared/types/Sda';

export type SdaRenderedEvents = {
    subscribe(callback: (event: SdaRenderedEventData) => void): () => void;
};

export const sdaRenderedEvents: SdaRenderedEvents = {
    subscribe: (callback) => otto.sda.renderedEvent.subscribe(callback),
};
